<template>
  <v-layout column>
    <h2 class="primary--text headline font-weight-light">Postup</h2>
    <v-layout v-for="(step, index) in steps" :key="index" my-2 column>
      <h3 v-if="step.section !== 'Default'" class="title font-weight-light mt-1">
        {{ step.section }}
      </h3>
      <v-layout
        v-for="(step, index) in step.steps"
        :key="index"
        my-2
      >
        <v-flex mr-2 shrink>
          <v-avatar color="grey lighten-3" size="25">
            <span>{{ index + 1 }}</span>
          </v-avatar>
        </v-flex>
        <v-flex class="body-2">{{ step }}</v-flex>
      </v-layout>
    </v-layout>
    <v-flex mt-1 v-if="!steps.length"> {{ emptyText }} </v-flex>
  </v-layout>
</template>

<script>
import { compareByOrderProperty } from "@/utils/SortUtils";

export default {
  name: "RecipeSteps",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: "Postup nebyl zadán"
    }
  },
  computed: {
    sortedSteps() {
      return this.steps.slice().sort(compareByOrderProperty);
    }
  }
};
</script>
